<template>
  <div id="StudentSiblingReport">
    <div class="container admin-wrap mt-5">
      <div class="row header mb-3">
        <div class="col-lg-5">
          <h3 class="text-left">Student Sibling Report</h3>
        </div>
        <div class="col-lg-7 divSelection">
          <el-select v-model="ddlSelection" placeholder="Search" class="pro-edt-select" @change="BindStudentSiblingReport()" style="margin-right: 10px">
            <el-option v-for="item in ddlSelectionList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </div>
      </div>
      <div class="pb-5">
        <div class="empty-list_image" v-if="studentListInt.length < 1">
          <strong>{{ startupText }}</strong>
          <img src="../assets/notfound.png" />
        </div>
        <div v-if="studentListInt.length > 0" class="datatable_group">
          <el-button type="primary" round @click="exportExcel()" class="btnExport"><i class="fa fa-file-excel-o" aria-hidden="true"></i> Export</el-button>

          <data-tables :data="studentListInt">
            <el-table-column
              v-for="studentListInfo in studentList"
              :prop="studentListInfo.prop"
              :label="studentListInfo.label"
              :key="studentListInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import XLSX from 'xlsx'

export default {
  name: 'StudentSiblingReport',
  async created() {},
  async mounted() {},
  data() {
    return {
      startupText: 'No Record...',
      ddlSelection: '',
      ddlSelectionList: ['Without Pending', 'With Pending'],

      studentListInt: [],
      studentList: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Family Name',
        },
        {
          prop: 'Regst_date_convert',
          label: 'Commencement Date',
        },
        {
          prop: 'SCH_Name',
          label: 'School',
        },
        {
          prop: 'SMT_Code',
          label: 'Year',
        },
        {
          prop: 'CRS_Course_Name',
          label: 'Level',
        },
        {
          prop: 'CLS_ClassName',
          label: 'Class Name',
        },
        {
          prop: 'CLS_Batch',
          label: 'Programme',
        },
        {
          prop: 'SCRS_From_Date_convert',
          label: 'From Date',
        },
        {
          prop: 'SCRS_To_Date_convert',
          label: 'To Date',
        },
        {
          prop: 'SCRS_Status',
          label: 'Status',
        },
        {
          prop: 'PAR_Father_Email',
          label: 'Father Email',
        },
        {
          prop: 'PAR_Mother_Email',
          label: 'Mother Email',
        },
        {
          prop: 'Siblings',
          label: 'Siblings',
        },
        {
          prop: 'PAR_Family_Number',
          label: 'Family No',
        },
      ],
    }
  },
  methods: {
    async BindStudentSiblingReport() {
      this.$vs.loading()

      this.studentListInt = []

      try {
        const response = await DataSource.shared.getStudentSiblingReport(this.ddlSelection)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error',
            })
          } else if (response.code === '2') {
            this.$notify({
              title: 'No Record',
              message: 'No Record Found',
            })
          } else {
            this.studentListInt = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }

      this.$vs.loading.close()
    },
    exportExcel() {
      let exportExcelObject = []

      this.studentListInt.forEach(m => {
        let temp = {
          'Student ID': m.Index_No,
          'First Name': m.Full_Name,
          'Middle Name': m.Middle_name,
          'Family Name': m.Last_name,
          'Commencement Date': m.Regst_date_convert,
          School: m.SCH_Name,
          SMT_Code: m.Year,
          Level: m.CRS_Course_Name,
          'Class Name': m.CLS_ClassName,
          Programme: m.CLS_Batch,
          'From Date': m.SCRS_From_Date_convert,
          'To Date': m.SCRS_To_Date_convert,
          Status: m.SCRS_Status,
          'Father Email': m.PAR_Father_Email,
          'Mother Email': m.PAR_Mother_Email,
          Siblings: m.Siblings,
          'Family No': m.PAR_Family_Number,
        }

        exportExcelObject.push(temp)
      })

      var sheet1WS = XLSX.utils.json_to_sheet(exportExcelObject)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, sheet1WS, 'sheet1') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'Student Sibling Report.xlsx') // name of the file is 'book.xlsx'
    },
  },
}
</script>

<style scoped>
.divSelection {
  text-align: right;
}
.btnExport {
  display: block;
}
</style>
